<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title
            >Cobro <b>{{ detail.code }}</b></v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container v-if="detail.internal_account != undefined">
          <v-card-title>
            <strong>Cobro No: </strong>
            {{ detail.code }}
            <v-spacer></v-spacer>
            <v-btn
              v-if="!detail.is_cancelled"
              class="mx-2"
              fab
              dark
              color="indigo"
              :loading="loadingPdf"
              @click="getBillingPDF()"
            >
              <v-icon dark>mdi-printer</v-icon>
            </v-btn>
          </v-card-title>
          <v-card height="100%">
            <v-row>
              <v-col cols="12" md="4">
                <v-list three-line subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Cuenta Origen</v-list-item-title>
                      <v-list-item-subtitle>{{
                        detail.internal_account.source_company.second_name
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Creado por</v-list-item-title>
                      <v-list-item-subtitle>{{
                        detail.created_by.username
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" md="4">
                <v-list three-line subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Cuenta Destino</v-list-item-title>
                      <v-list-item-subtitle>{{
                        detail.internal_account.destination_company.second_name
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Fecha de creación</v-list-item-title>
                      <v-list-item-subtitle>{{
                        detail.created | date
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" md="4">
                <v-list three-line subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Total Cobro:</v-list-item-title>
                      <v-list-item-subtitle
                        >Q.{{ detail.amount | currency }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-card>
          <br />
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="detail.details"
            class="elevation-1"
            disable-pagination
            disable-sort
            hide-default-footer
          >
            <template v-slot:item.quantity="{ item }">
              {{ item.quantity | currency }}
            </template>
            <template v-slot:item.price="{ item }">
              Q.{{ item.price | currency }}
            </template>
            <template v-slot:item.amount="{ item }">
              Q.{{ item.amount | currency }}
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import requests from "@/services/requests";
import blobResponse from "@/utils/response.blob";
export default {
  name: "BillingForm",
  components: {
    // InternalAccountField: () => import("@/components/fields/AccountInternalField.vue"),
    // CompanyField: () => import("@/components/fields/CompanyField.vue"),
  },
  props: {
    dialog: { type: Boolean, required: true },
    billingId: { type: String, required: true },
  },
  data() {
    return {
      loadingPdf: false,
      detail: {},
      headers: [
        { text: "Descripción", value: "description" },
        { text: "Cantidad", value: "quantity" },
        { text: "Precio", value: "price" },
        { text: "Monto", value: "amount" },
      ],
    };
  },
  methods: {
    getBillingID() {
      requests
        .get("/api/bussiness-connector/internal-billing/" + this.billingId)
        .then((response) => {
          this.detail = response.data;
        });
    },
    getBillingPDF() {
      this.loadingPdf = true;
      requests
        .get("/api/pdf/internal-billing/" + this.billingId)
        .then((response) => {
          if (response.status == 200) {
            blobResponse(response.data, "application/pdf");
          }
        })
        .catch((error) => {
          console.error("ERROR:", error);
          this.snackbarText = "Ha ocurrido un error";
          this.snackbarStatus = true;
        });
      this.loadingPdf = false;
    },
    close() {
      this.$emit("close");
    },
  },
  watch: {},
  mounted() {
    this.getBillingID();
  },
};
</script>
